module.exports = __webpack_public_path__ + "v1.8.4.20261010/img/003.b4e2dca4.png";